import { Colors } from './types';
import { globalSystemColors } from './constants';

export const darkColors: Colors = {
  text: {
    primary: '#fefefe',
    secondary: 'rgba(254, 254, 254, 0.60)',
    basic: '#505050',
    platinum: '#7a66de',
    silver: '#888686',
    gold: '#9c8651',
    white: '#fefefe',
    tertiary: '#bcbcbc'
  },
  background: {
    primary: '#1b1b1d',
    secondary: '#010101',
    tertiary: '#2a2a2d',
    tertiaryReverse: '#f8f8f8',
    footer: '#1b1b1d',
    mortgageLabel: 'rgba(42, 42, 45, 0.90)'
  },
  loginButton: {
    bg: '#505050',
    border: '#505050',
    hoveredBorder: '#2a2a2d'
  },
  border: {
    primary: '#262627',
    secondary: 'rgba(255, 255, 255, 0.10)',
    primaryReverse: '#eae5e1',
    secondaryReverse: '#eaeaea'
  },
  systemColors: {
    ...globalSystemColors,
    brand: 'linear-gradient(320deg, #decfa7 -8.11%, #ede6d2 69.11%)',
    lightBlue: '#dae8ff',
    lightRed: '#ffe6e5',
    autumnRed: '#d93d04',
    naiveBlue: '#a5c5fc'
  },
  promotion: {
    bump: '#78c91d',
    vip: '#ff3d00',
    premium: '#ff9f2b'
  }
};
